import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import classNames from "classnames";
library.add(fas);

const EditplatformchargeModal = (props) => {
  // FIX 1: Get ID from the correct prop (either 'id' or 'show')
  const id = props.id || props.show; // Support both prop names
  const { postData, getData } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const [data, setData] = useState({});

  const getEditData = async () => {
    try {
      // Only fetch if id is a valid number (not boolean)
      if (id && typeof id === "number") {
        const response = await getData(`/admin/vendor/${id}`);
        if (response?.data) {
          reset({ platform_charges: response.data.commission });
          setData(response.data);
        }
      }
    } catch (error) {
      console.error("Error fetching edit data:", error);
    }
  };

  useEffect(() => {
    if (id && typeof id === "number") {
      getEditData();
    }
  }, [id]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const onSubmit = async (data) => {
    reset({ platform_charges: "" });

    try {
      const d = new FormData();
      d.append("platform_charges", data?.platform_charges);

      // FIX 2: Ensure ID is a valid number before making API call
      if (!id || typeof id !== "number") {
        console.error("Invalid ID:", id);
        setShowModal({ code: 0, message: "Invalid vendor ID" });
        return;
      }

      // CHANGE THIS LINE - Use the approve endpoint instead
      // const response = await postData(`/admin/vendor/design/${id}`, d);
      const response = await postData(`/admin/vendor/design/edit/${id}`, d);

      if (response?.success) {
        await setShowModal({ code: response?.code, message: response?.data });
      } else {
        await setShowModal({ code: response?.code, message: response?.data });
      }

      setTimeout(() => {
        setShowModal(0);
        // FIX 3: Safely call handleClose
        if (props.handleClose && typeof props.handleClose === "function") {
          props.handleClose();
        }
        // Refresh the parent data after approval
        if (props.onApprove && typeof props.onApprove === "function") {
          props.onApprove(data?.platform_charges);
        }
      }, 1000);
    } catch (error) {
      console.log("API Error:", error);
      setShowModal({
        code: 0,
        message: error?.message || "Something went wrong",
      });
    }
  };

  const handleCloseModal = () => {
    reset({ platform_charges: "" });
    if (props.handleClose && typeof props.handleClose === "function") {
      props.handleClose();
    }
  };

  return (
    <>
      <Modal
        show={props.show === true || props.show === false ? props.show : true}
        onHide={handleCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Add Platform Charges
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)} role="form">
            <Row className="">
              <Col md={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <div className="">
                        <Form.Label>Platform Charge</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          type="text"
                          placeholder="Enter platform charges"
                          className={classNames({
                            "is-invalid": errors?.platform_charges,
                          })}
                          {...register("platform_charges", {
                            required: "Platform Charge is required",
                            validate: (value) => {
                              if (!value)
                                return "Platform Charge is required";

                              const num = parseFloat(value);

                              if (isNaN(num)) return "Only numbers are allowed";
                              // if (num < 0)
                              //   return "Value should not be less than 0";
                              // if (num >= 100)
                              //   return "Value should be less than 100";

                              return true;
                            },
                          })}
                          onKeyDown={(e) => {
                            // Allow control keys
                            const allowedKeys = [
                              "Backspace",
                              "Delete",
                              "Tab",
                              "ArrowLeft",
                              "ArrowRight",
                              "Home",
                              "End",
                            ];

                            if (allowedKeys.includes(e.key)) return;

                            // Allow one decimal point only
                            if (e.key === ".") {
                              if (e.target.value.includes(".")) {
                                e.preventDefault();
                              }
                              return;
                            }

                            // Allow digits only
                            if (!/^\d$/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onInput={(e) => {
                            let value = e.target.value;

                            // Remove invalid characters
                            value = value.replace(/[^0-9.]/g, "");

                            e.target.value = value;
                          }}
                        />
                      </InputGroup>
                      {errors?.platform_charges && (
                        <span className="text-danger">
                          {errors?.platform_charges?.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center gap-2">
                  <CancelButton name="Cancel" handleClose={handleCloseModal} />
                  <button type="submit" className="btn btn-primary">
                    Save and Approve
                  </button>
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditplatformchargeModal;
